"use client";

import Tabs, { ITab } from "~/components/layout/tabs/tabs";
import { TabType } from "~/components/layout/tabs/types";
import { getSiteImageFullPath } from "~/lib/siteMedia";
import messages from "~/resources/messages/en-us/app/(default)/(policy)/privacypolicies/privacypolicies.json";

interface IPrivacyPoliciesTabsProps {}

const PrivacyPoliciesTabs: React.FC<IPrivacyPoliciesTabsProps> = () => {
	const tabs: ITab[] = [
		{
			headingCaption: messages.privacyPolicies.forWebsiteVisitorsTabPrimaryCaption.value,
			imagePath: getSiteImageFullPath("privacypolicies/visitors.png"),
			subheadingCaption: messages.privacyPolicies.forWebsiteVisitorsTabSecondaryCaption.value,
			tabKey: "epic-privacy-policy",
		},
		{
			headingCaption: messages.privacyPolicies.forPatientsTabPrimaryCaption.value,
			imagePath: getSiteImageFullPath("privacypolicies/patients.png"),
			subheadingCaption: messages.privacyPolicies.forPatientsTabSecondaryCaption.value,
			tabKey: "mobile-policy-patient",
		},
		{
			headingCaption: messages.privacyPolicies.forProvidersTabPrimaryCaption.value,
			imagePath: getSiteImageFullPath("privacypolicies/providers.png"),
			subheadingCaption: messages.privacyPolicies.forProvidersTabSecondaryCaption.value,
			tabKey: "mobile-policy-provider",
		},
	];
	return (
		<Tabs
			tabs={tabs}
			tabsKey={"privacy-policy"}
			defaultSelectedTabKey={"epic-privacy-policy"}
			tabType={TabType.big}
		/>
	);
};

export default PrivacyPoliciesTabs;
